import React, { useEffect, useState } from "react";
import ReactMarkdown from "react-markdown";

const shellStyle = { padding: "50px" };

/**
 * Renders a markdown file from `public/` (e.g. `/terms.md`).
 */
export default function LegalMarkdown({ src }) {
  const [content, setContent] = useState("");
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    setError(null);
    setContent("");
    fetch(src)
      .then((res) => {
        if (!res.ok) throw new Error(String(res.status));
        return res.text();
      })
      .then((text) => {
        if (!cancelled) setContent(text);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      });
    return () => {
      cancelled = true;
    };
  }, [src]);

  if (error) {
    return (
      <div style={shellStyle}>
        <p role="alert">Could not load this document.</p>
      </div>
    );
  }

  if (!content) {
    return null;
  }

  return (
    <article style={shellStyle}>
      <ReactMarkdown>{content}</ReactMarkdown>
    </article>
  );
}
